import { useEffect, useRef, useState } from "react";
import { CircularProgress } from "@mui/material";
import CurrencyConverter from "@heartinz/currency_subunit_converter";
import DateConverter from "@heartinz/date_and_time_processor";
import AxiosInstance from "../utils/AxiosInstance";
import { useNetwork } from "../context/NetworkContext";
import { useShowAlert } from "../context/AlertContext";
import { usePermission } from "../context/PermissionContext";
import handleError from "../constants/handleError";
export default function ReturnSale({
  saleID,    
  handleSelectedReturnSale,
  saleReturnNo,
  version,
  handlelatestSale,
  closeAuto,
  setCloseAuto,
  latestVersion,
}) {
  const hasFetched = useRef(false);
  const [saleOpen, setSaleOpen] = useState(false);
  const [saleHistoryDate, setSaleHistoryDate] = useState([]);
  const [page, setPage] = useState(1);
  const [loadingMore, setLoadingMore] = useState(false);
  const [hasMore, setHasMore] = useState(true); 

  const { checkNetwork } = useNetwork();
  const showAlert = useShowAlert();
  const loadingRef = useRef(false);
  const { permission, hasModulePermission, blockedPermissions } =
    usePermission();

  const getBgColor = (status) => {
    if (!status || typeof status !== "string") return "bg-label-secondary";
    switch (status) {
      case "ADDED":
        return "bg-label-success";
      case "UPDATED":
        return "bg-label-bird";
      case "DELETED":
        return "bg-label-red";
      default:
        return "bg-label-secondary";
    }
  };

  const getSaleTrack = (status) => {
    switch (status) {
      case "ADDED":
        return "Original";
      case "UPDATED":
        return "Modified";
      case "DELETED":
        return "Cancelled";
      default:
        return status;
    }
  };

  const handleSaleHistory = async (saleId,pageNum = 1) => {
    try {
      if (!checkNetwork()) return;
      if (loadingRef.current) return;
      loadingRef.current = true;
      setLoadingMore(true);  
      const limit = 10;
      const response = await AxiosInstance.get(
        `module/salereturn/list/${saleId}?pageno=${pageNum}&limit=${limit}`,
      );
      const history = response.data?.results || [];
     if (pageNum === 1) { 
      setSaleHistoryDate(history);
      handlelatestSale(history[history?.length - 1]);
      setPage(1);    
      } else {       
        setSaleHistoryDate((prev) => [...prev, ...history]);
        setPage(pageNum);
      }

      if (history.length < limit) {
        setHasMore(false);
      } else {
        setHasMore(true);
      }
    } catch (error) {
      handleError(error, showAlert);
      return null;
    }
    finally {     
       loadingRef.current = false;
       setLoadingMore(false);
    }
  };

 const handleScroll = (e) => {
  const { scrollTop, scrollHeight, clientHeight } = e.target;
  if (
    scrollHeight - scrollTop <= clientHeight + 20 &&
    !loadingMore &&
    hasMore
  ) {
    handleSaleHistory(saleID, page + 1);
  }
};

  const handleToggleSale = () => {
    const opening = !saleOpen;
    setSaleOpen(opening);
    setCloseAuto(true);
    if (opening && !hasFetched.current && saleID) {
      handleSaleHistory(saleID);
      hasFetched.current = true;
    }
  };

  useEffect(() => {
    if (!closeAuto) {
      setSaleOpen(false);
    }
  }, [closeAuto]);

  // useEffect(()=>{
  //     if (hasFetched.current) return;
  //     hasFetched.current = true;
  //    if((hasModulePermission("SALE") || permission === undefined) &&
  //     (blockedPermissions("SALE:history") || permission === undefined))(
  //     handleSaleHistory(isData?._id)
  //     )
  // },[])
  return (
    <>
      {(hasModulePermission("SALE") || permission === undefined) &&
        (blockedPermissions("SALE:history") || permission === undefined) && (
          <div
            className="mt-2"
            style={{
              border: "1px solid #e5e7eb",
              borderRadius: 8,
              overflow: "hidden",
            }}
          >
            <div
              className="d-flex justify-content-between align-items-center"
              style={{
                padding: "8px 8px",
                cursor: "pointer",
                background: "#f9fafb",
              }}
              onClick={handleToggleSale}
            >
              <span className="font-13 fw-600">Return Sale History</span>
              <i
                className="bx bx-chevron-down font-18"
                style={{
                  transition: "transform 0.2s",
                  transform:
                    saleOpen && closeAuto ? "rotate(180deg)" : "rotate(0deg)",
                }}
              />
            </div>

            {saleOpen && closeAuto && (
              <div  onScroll={handleScroll} style={{ maxHeight: "320px", overflowY: "auto",scrollbarWidth: "thin",                
              WebkitOverflowScrolling: "touch" }}>
              <ul className="p-2 m-0 list-unstyled" style={{ width: "100%" }}>
                {saleHistoryDate?.length > 0 ? (
                  saleHistoryDate
                    // ?.slice()
                    // .reverse()
                    ?.map((sale, idx) => {
                      const displayTime = DateConverter
                        ? `${
                            DateConverter.ISOToDisplayFormat(
                              DateConverter.convertToTimeZone(
                                sale?.saleReturnDate,
                                "Asia/Kolkata",
                              ),
                            ).date
                          } `
                        : sale?.saleReturnDate;
                      const grandTotal = CurrencyConverter
                        ? CurrencyConverter.toCurrency(
                            sale?.returnGrandTotalRounded || 0,
                            "INR",
                          )
                        : sale?.returnGrandTotalRounded || 0;

                      return (
                        <li
                          key={sale?._id || idx}
                          className={`dropdown-item ${(version && version === sale?.saleVersion) || (saleReturnNo && saleReturnNo === sale?.saleReturnNo)? "active": ""}`}
                          style={{ cursor: "pointer", padding: "0.483rem" }}
                          onClick={() => handleSelectedReturnSale(sale)}
                        >
                          <div className="fw-semibold text-dark d-flex justify-content-between align-items-center">
                            <span>
                            
                              {sale?.saleReturnNo}
                            </span>
                            <small
                              className={`badge rounded-pill ${getBgColor(
                                sale?.saleTrack,
                              )}`}
                            >
                              {getSaleTrack(sale?.saleData?.saleTrack)}
                            </small>
                            <small className="badge bg-label-fall rounded-pill">
                              ₹{grandTotal}
                            </small>
                          </div>
                          <div className="d-flex justify-content-between align-items-center mt-1">
                            <small className="text-muted">
                              Items: {sale?.totalReturnItemCount || 0}
                            </small>
                            <small className="text-muted">{displayTime}</small>
                          </div>
                        </li>
                      );
                    })
                ) : (
                  <li className="dropdown-item text-muted">No Sale History</li>
                )}
              </ul>
                  {saleHistoryDate?.length > 0 && (
                      <>
                        {hasMore && (
                          <div className="p-1 bg-light border-top text-center">
                            {loadingMore && (
                      <div className="text-center ">
                        <CircularProgress size={20} />
                      </div>
                    )}
                    </div>
                  )}
                </>
              )}
              </div>
            )}
          </div>
        )}
    </>
  );
}
